import { render } from "./deals-list-modal.vue?vue&type=template&id=c4fa3de8"
import script from "./deals-list-modal.vue?vue&type=script&lang=js"
export * from "./deals-list-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__